import { render, staticRenderFns } from "./ResendInviteModal.vue?vue&type=template&id=a98aae4c"
import script from "./ResendInviteModal.vue?vue&type=script&lang=js"
export * from "./ResendInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports